export const INVENTORY_CONFIG = `const componentConfig = {
    "inventoryItem": "%inventoryItem%",
    "theme":"%themeComposer%",%componentsConfig%%ipOverrides%
}`;

export const COMPONENTS_CONFIG = `
    "components": {%customizeActionButtons%%customizeSearchControllers%%customizeFilterButtons%%customizeInventoryTable%
}`;
// eslint-disable-next-line
export const DASHBOARD_ACTIONS = `"import-dashboard",
                    "add-new-dashboard",`;
// eslint-disable-next-line
export const REPORT_ACTIONS = `"add-new-report",`;

export const CUSTOMIZE_ACTION_BUTTONS = `
        "actions": {
            "visible": true,
            "showDefaults": true,

            "order": [
                    %actions%
                    "custom"
                ],
                "visibility": [
                    %actions%
                    "custom"
                ],
            
            "definitions": [
                {
                    "id": "custom",
                    "label": "Custom Button",
                    "intent": "primary",
                    "onClick": () => alert('Custom button clicked!')
                    /*
                    // link example
                    "onClick": {
                        "type": "link",
                        "href": "https://dashboards.company.com/create",
                        "target": "_blank"
                    }
                    */
                }
            ]
        },`;

export const CUSTOMIZE_SEARCH_CONTROLLERS = `
        "search": {
            "visible": true,
            "defaultValue": "",
            "placeholder": "My Search"
        },`;

export const CUSTOMIZE_FILTER_BUTTONS = `
        "filters":{
            "visible": true,
            "showDefaults": true,

            "order": [
                    "all",
                    "favorites",
                    "myitems",
                    "shared",
                    "custom"
                ],
                "visibility": [
                    "all",
                    "favorites",
                    "myitems",
                    "shared",
                    "custom"
                ],
            
            "definitions": [
                {
                    "id": "custom",
                    "icon": {
                        "src": "https://cdn-icons-png.flaticon.com/512/742/742751.png"
                    },
                    "label": "test",
                    "htmlTitle": "htmlTitle", // tooltip //
                    "predicate": (item, idx, array) => {
                    return item.favorite === true;
                    } // function query
                }
            ]
        },`;

export const CUSTOM_CELL_RENDERER = `
//Find more about how to customise this here:
// https://www.ag-grid.com/javascript-data-grid/component-cell-renderer/#cell-component-function
class CustomCellRenderer {
    init(params) {
        this.eGui = document.createElement('div');
        this.eGui.style.color = params.color || ''; // Fallback color if params.color is undefined

        // Create a clickable link
        const link = document.createElement(params.element);
        link.textContent = params.textContent || params.data?.name || 'Unnamed';
        link.style.cursor = 'pointer';
        link.addEventListener('click', () => {
            if (params.onClick) {
                params.onClick(params.data);
            }
        });
        // Append the link to the main container
        this.eGui.appendChild(link);
    }

    getGui() {
        return this.eGui;
    }
}
`;

export const CUSTOMIZE_INVENTORY_TABLE = `
        "table": {
            "defaultSort": {
                "colId": "name", // ["favorite", "name", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                "sortDirection": "asc"
            },
            
            "columns": {
                "showDefaults": true,

                "order": [
                        "favorite",
                        "nameColumn",
                        "newColumn",
                        "dataSource",
                        "author",
                        "dateModified",
                        "permissions",
                        "schedule",
                        "actions"
                    ],
                    "visibility": [
                        "favorite",
                        "nameColumn",
                        "newColumn",
                        "dataSource",
                        "author",
                        "dateModified",
                        "permissions",
                        "schedule",
                        "actions"
                    ],
           
                
                "definitions": [
                //For embedding dashboards using "name" column
                //Embed click handler
                    {
                        "colId": "nameColumn",
                        "field": "name",
                        "headerName": "Name",
                        "minWidth" : 100,
                        "maxWidth" : 100,  
                        "sortable": true,
                        "cellRendererParams": { 
                            "onClick": {
                                "type": "embed",
                                "parentElement": "#widget-holder",
                            },
                        },
                        "cellRenderer": CustomCellRenderer,
                    },
                    //For adding a new column
                    //Function Click handler
                    {
                        "colId": "newColumn", //case on ID was wrong on docs
                        "field": "Custom",
                        "headerName": "Custom",
                        "minWidth" : 100,
                        "maxWidth" : 100,  
                        "sortable": true,
                        "comparator": "", // function
                        "cellRendererParams": { 
                            "element": "p",
                            "textContent": "ALERT",
                            "onClick": (data) => alert(\`You clicked on \${data.inventoryItemId} a custom column!\`),
                            "color": "limegreen",
                        },
                        "cellRenderer": CustomCellRenderer,
                    },
                    //For embedding dashboards using any other column
                    //Embed Click handler
                    {
                        "colId": "author",// ["favorite", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                        "cellRendererParams": {
                            "onClick": {
                                "type": "embed",
                                "parentElement": "#widget-holder",
                                "componentParams": {
                                    // optional component params
                                }
                            }
                        }
                    },
                    //Link Click handler
                    {
                        "colId": "dateModified",// ["favorite", "dataSource", "author", "dateModified", "permissions", "schedule", "actions"]
                        "cellRendererParams": {
                            "onClick": {
                                "type": "link",
                                "href": "www.dashboards/\${inventoryItemId}",
                                "target": "_blank"
                            }
                        }
                    }
                ]
            }
        },`;

export const CUSTOMIZE_ACTION_BUTTONS_HELPERS = `
const alertCell = () => alert('You clicked on a custom column!');

const closeEmbed = () => {
    document.getElementById('dashboard-holder').innerHTML = '';
}
`;

export const CUSTOMIZE_ACTION_BUTTONS_HTML_CODE = `
    <div
        class="dashboard-holder"
        id="dashboard-holder"
    ></div>
    <button class="close-btn" onclick="closeEmbed()">close dashboard</button>
`;

export const CUSTOMIZE_ACTION_BUTTONS_CSS_CODE = `
.dashboard-holder:not(:empty) {
    position: relative;
    flex-grow: 1;
}
.close-btn {
    display: none;
}
.dashboard-holder:not(:empty)~.close-btn {
    display: block;
}
`;
